import { render, staticRenderFns } from "./CostDescForm.vue?vue&type=template&id=65008963&"
import script from "./CostDescForm.vue?vue&type=script&lang=js&"
export * from "./CostDescForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports